import { createFailureTracker } from "../utils/failure-tracker.js";
//#region ../src/ar/capture-failure-tracker.ts
/**
* Capture Failure Tracker
*
* Tracks consecutive image capture failures and notifies users when
* multiple frames fail to capture (e.g., low memory on mobile devices).
*
* Field Test Readiness Issue #11: Silent image capture failures
*
* Thin wrapper around the generic failure tracker factory.
*/
/**
* Default configuration values.
*/
const DEFAULT_CAPTURE_TRACKER_CONFIG = { failureThreshold: 5 };
/**
* User-facing warning message when threshold is exceeded.
*/
const CAPTURE_FAILURE_WARNING = "Multiple image captures failed. Device may be low on memory.";
/**
* Create a new capture failure tracker.
*
* @param config - Configuration with warning callback and optional threshold
* @returns CaptureFailureTracker instance
*/
function createCaptureFailureTracker(config) {
	const tracker = createFailureTracker({
		label: "CaptureFailure",
		warningMessage: CAPTURE_FAILURE_WARNING,
		defaultThreshold: DEFAULT_CAPTURE_TRACKER_CONFIG.failureThreshold,
		onWarning: config.onWarning,
		failureThreshold: config.failureThreshold,
		logLevel: "warn"
	});
	return {
		recordSuccess: () => tracker.recordSuccess(),
		recordFailure: () => tracker.recordFailure(),
		getFailureCount: () => tracker.getFailureCount(),
		hasWarned: () => tracker.hasWarned(),
		reset: () => tracker.reset()
	};
}
//#endregion
export { CAPTURE_FAILURE_WARNING, DEFAULT_CAPTURE_TRACKER_CONFIG, createCaptureFailureTracker };
